module.exports = __webpack_public_path__ + "static/designAlt-d5d587f8b587c0c442f54605d8cdf85f.svg";